import { useTranslation } from "@redotech/redo-i18n";
import type { DropoffNearbyState } from "@redotech/redo-return-core-common/return-flow/condition-validate";
import { ConditionTypeDetailsProps } from "@redotech/redo-return-ui/flows/return-flow/condition";
import { RedoTextInput } from "@redotech/redo-web/arbiter-components/input/redo-text-input";
import { memo } from "react";

export const DropoffNearbyDetails = memo(function DropoffNearbyDetails({
  state,
  setState,
  disabled,
}: ConditionTypeDetailsProps<DropoffNearbyState>) {
  const { t } = useTranslation();
  return (
    <RedoTextInput
      description={t(
        "Applies when the customer's nearest drop-off location is within this many miles.",
      )}
      inputTypeHint="number"
      label={t("Drop-off within (miles)")}
      min={1}
      onBlur={() => setState(String(+state))}
      setValue={(e) => setState(e)}
      size="sm"
      state={disabled ? "disabled" : "default"}
      step={0.25}
      value={state}
    />
  );
});
